import { FavPopupMainFavAdded } from 'components/search-bar-fav/popover-fav-added/fav-popup-main-fav-added.js';
import { FavPopupMainManageFavs } from 'components/search-bar-fav/popover-manage-favs/fav-popup-main-manage-favs.js';
import { useState } from 'react';
import { useAppSelector } from 'redux-state/configure-store.js';
import { FavouriteCurrentLocation } from './hooks/fav.location.current.hook.js';
import { UsePageFavouriteProps } from './hooks/page-favourite-properties.js';
import { FavPopupChildFavAdded } from './popover-fav-added/fav-popup-child-fav-added.js';
import { FavPopupChildManageFavs } from './popover-manage-favs/fav-popup-child-manage-favs.js';
import { SearchBarFavouriteDisplayLocations } from './searchbar-fav-locations-display.js';

/** Displays favourite icons (favourited locations, star and add) on search bar and associated popups to manage favourites. */
export const FavouriteSearchBar = () => {
  const location = useAppSelector((state) => state.LAYOUT.screen?.location);
  const [previewLocationFavourite, setPreviewLocationFavourite] = useState(false);
  const { currentLocationFavourite } = FavouriteCurrentLocation({ location });
  const { displayFavouriteIcon } = UsePageFavouriteProps();

  return (
    <div className="u-flex u-flexAlignItemsCenter">
      <SearchBarFavouriteDisplayLocations
        currentLocationFavourite={currentLocationFavourite}
        addCurrentLocation={previewLocationFavourite}
      />
      <div className="u-flex u-flexAlignItemsCenter" style={{ gap: '0.5rem' }}>
        {displayFavouriteIcon && (
          <FavPopupMainFavAdded>
            <FavPopupChildFavAdded setPreviewLocationFavourite={setPreviewLocationFavourite} />
          </FavPopupMainFavAdded>
        )}
        <FavPopupMainManageFavs>
          <FavPopupChildManageFavs />
        </FavPopupMainManageFavs>
      </div>
    </div>
  );
};
